import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIEmptyState from 'UIComponents/empty/UIEmptyState';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UILink from 'UIComponents/link/UILink';
import { trackEvent } from 'automation-ui-canvas/utils/trackingUtils';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useHistory } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const navigateToVersionPanel = history => {
  const searchParams = new URLSearchParams(history.location.search);
  searchParams.set('panel-open', 'version');
  trackEvent(Trackables.PERFORMANCE_HISTORY_REVISION_HISTORY);
  history.push({
    pathname: history.location.pathname,
    search: searchParams.toString()
  });
};
const MultiRevisionEmptyState = ({
  objectTypeId
}) => {
  const history = useHistory();
  return /*#__PURE__*/_jsx(UIEmptyState, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.enrollmentHistory.multiRevisionState.title"
    }),
    primaryContent: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "automation.enrollmentHistory.multiRevisionState.description_cob",
          objectTypeId: objectTypeId
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "automation.enrollmentHistory.multiRevisionState.link_jsx",
          elements: {
            Link: ({
              children
            }) => {
              return /*#__PURE__*/_jsx(UILink, {
                "data-test-id": "enrollment-panel-template-setup-alert-link",
                onClick: () => navigateToVersionPanel(history),
                children: children
              });
            }
          }
        })]
      })
    }),
    secondaryContent: /*#__PURE__*/_jsx(UIIllustration, {
      name: "workflows",
      width: "50%"
    })
  });
};
export default MultiRevisionEmptyState;